import * as moment from 'moment';
import { extendMoment } from 'moment-range';
window['moment'] = extendMoment(moment);
